import { render, staticRenderFns } from "./ReferMorakhasiList.vue?vue&type=template&id=8506c7e8&scoped=true&"
import script from "./ReferMorakhasiList.vue?vue&type=script&lang=js&"
export * from "./ReferMorakhasiList.vue?vue&type=script&lang=js&"
import style0 from "./ReferMorakhasiList.vue?vue&type=style&index=0&id=8506c7e8&scoped=true&lang=css&"
import style1 from "./ReferMorakhasiList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8506c7e8",
  null
  
)

export default component.exports